'use client';

import { useEffect } from 'react';

export default function ChunkErrorHandler() {
  useEffect(() => {
    const handleChunkError = (event: ErrorEvent) => {
      if (
        event.message.includes('ChunkLoadError') ||
        event.message.includes('Loading chunk') ||
        event.message.includes('Failed to fetch dynamically imported module') ||
        event.message.includes('timeout')
      ) {
        console.warn('Chunk loading error detected, reloading page...');
        // Add small delay to prevent rapid reload loops
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (
        event.reason?.message?.includes('ChunkLoadError') ||
        event.reason?.message?.includes('Loading chunk') ||
        event.reason?.message?.includes('timeout')
      ) {
        console.warn('Chunk loading promise rejection detected, reloading page...');
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    };

    window.addEventListener('error', handleChunkError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleChunkError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}